import React, { useEffect } from "react";
import { useRouter } from "next/router";
import Head from "next/head";
import funnel from "../../styles/Funnel.module.css";
import axios from "axios";
import { styled } from "@mui/material/styles";
import Check from "@mui/icons-material/Check";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import Mortgage from "../../component/funnel/mortgage";
import Deposit from "../../component/funnel/deposit";
import State from "../../component/funnel/state";
import Transportation from "../../component/funnel/transportation";
import Schools from "../../component/funnel/schools";
import { useCookies } from "react-cookie";

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "var(--primary-color)",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "var(--primary-color)",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  color: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#eaeaf0",
  display: "flex",
  height: 22,
  alignItems: "center",
  ...(ownerState.active && {
    color: "var(--primary-color)",
  }),
  "& .QontoStepIcon-completedIcon": {
    color: "var(--primary-color)",
    zIndex: 1,
    fontSize: 18,
  },
  "& .QontoStepIcon-circle": {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

const BackButton = styled(Button)(({ theme }) => ({
  color: "var(--primary-color)",
  border: "1px solid var(--primary-color)",
  fontWeight: "600",
  width: "180px",
  height: "45px",
  fontSize: "15px",
  "&:hover": {
    border: "1px solid var(--primary-color)",
    backgroundColor: "#01907d23",
  },
}));

const NextButton = styled(Button)(({ theme }) => ({
  color: "#fff",
  border: "1px solid var(--primary-color)",
  fontWeight: "600",
  width: "180px",
  height: "45px",
  fontSize: "15px",
  backgroundColor: "var(--primary-color)",
  "&:hover": {
    border: "1px solid var(--dark-color)",
    backgroundColor: "var(--dark-color)",
  },
}));

const steps = [1, 2, 3, 4, 5];

export default function SuburbFinderFunnel() {
  const [errorm, setErrorm] = React.useState(false);
  const [errord, setErrord] = React.useState(false);
  const [errordn, setErrordn] = React.useState(false);
  const [errors, setErrors] = React.useState(false);
  const [errorR, setErrorR] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [activeStep, setActiveStep] = React.useState(0);
  const [formData, setFormData] = React.useState({
    price_mortgage: "",
    price_deposit: "",
    state: null,
    Transportation: [],
    Type_of_schools: [],
    Gender: [],
    Level: [],
  });
  const [authToken, setAuthToken] = React.useState("");
  const Router = useRouter();
  const [lastBtn, setLastBtn] = React.useState("Finish");
  const [cookies, setCookie, removeCookie] = useCookies([
    "access_token",
    "price_mortgage",
    "price_deposit",
    "state",
    "type",
    "Transportation",
    "Type_of_schools",
    "Level",
    "Gender",
  ]);

  useEffect(() => {
    setAuthToken(cookies.access_token);
  }, []);

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <Mortgage
            formData={formData}
            setFormData={setFormData}
            errorm={errorm}
            setErrorm={setErrorm}
          />
        );
      case 1:
        return (
          <Deposit
            formData={formData}
            setFormData={setFormData}
            errord={errord}
            setErrord={setErrord}
            errordn={errordn}
            setErrordn={setErrordn}
          />
        );
      case 2:
        return (
          <State
            formData={formData}
            setFormData={setFormData}
            errors={errors}
            setErrors={setErrors}
          />
        );
      case 3:
        return <Transportation formData={formData} setFormData={setFormData} />;
      case 4:
        return <Schools formData={formData} setFormData={setFormData} />;
      default:
        return <Mortgage formData={formData} setFormData={setFormData} />;
    }
  }

  const handleNext = () => {
    if (activeStep === 0) {
      if (
        formData.price_mortgage === "" ||
        formData.price_mortgage.length <= 1
      ) {
        return setErrorm(true);
      } else {
        setCookie("price_mortgage", formData.price_mortgage, { maxAge: 1800 });
        setActiveStep(activeStep + 1);
        setErrorm(false);
      }
    } else if (activeStep === 1) {
      if (
        (parseInt(formData.price_deposit) <= 19 &&
          formData.price_deposit.length == 6) ||
        formData.price_deposit.length <= 5
      ) {
        return setErrordn(true);
      } else {
        setCookie("price_deposit", formData.price_deposit, { maxAge: 1800 });
        setActiveStep(activeStep + 1);
        setErrord(false);
        setErrordn(false);
      }
    } else if (activeStep === 2) {
      if (formData.state === null) {
        return setErrors(true);
      } else {
        setCookie("state", formData.state, { maxAge: 1800 });
        setActiveStep(activeStep + 1);
        setErrors(false);
      }
    } else if (activeStep === 3) {
      setCookie("Transportation", JSON.stringify(formData.Transportation), {
        maxAge: 1800,
      });
      setActiveStep(activeStep + 1);
    } else if (activeStep === 4) {
      setCookie("Type_of_schools", JSON.stringify(formData.Type_of_schools), {
        maxAge: 1800,
      });
      setCookie("Gender", JSON.stringify(formData.Gender), { maxAge: 1800 });
      setCookie("Level", JSON.stringify(formData.Level), { maxAge: 1800 });
      setCookie("type", 10, { maxAge: 1800 });
    }
    if (activeStep === steps.length - 1) {
      if (authToken) {
        setLastBtn("Loading...");
        setLoading(true);
        const data = {
          mortgage: cookies.price_mortgage,
          deposit: cookies.price_deposit,
          state: cookies.state,
          type: parseInt(cookies.type),
          transportation: cookies.Transportation,
          school_type: formData.Type_of_schools,
          school_level: formData.Gender,
          school_gender: formData.Level,
        };
        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        };
        axios.post(`${process.env.NEXT_PUBLIC_API_BASE_URL}/property/`, data, {
          headers: headers,
        });
        Router.push("/property-dashboard/");
      } else {
        setLastBtn("Loading...");
        Router.push("/register/");
      }
    }
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };
  return (
    <div>
      <React.Fragment>
        <div className={funnel.allFunnel}>
          <div className={funnel.funnel}>
            <Stepper activeStep={activeStep} connector={<QontoConnector />}>
              {steps.map((label, index) => (
                <Step key={label}>
                  <StepLabel StepIconComponent={QontoStepIcon}></StepLabel>
                </Step>
              ))}
            </Stepper>
            <div className={funnel.funnelBody}>
              {getStepContent(activeStep)}
              <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                {activeStep !== 0 && (
                  <BackButton
                    variant="outlined"
                    onClick={handleBack}
                    sx={{ mt: 3, ml: 1 }}
                  >
                    Back
                  </BackButton>
                )}

                <NextButton
                  variant="contained"
                  onClick={handleNext}
                  sx={{ mt: 3, ml: 1 }}
                >
                  {activeStep === steps.length - 1 ? lastBtn : "Continue"}
                </NextButton>
              </Box>
            </div>
          </div>
        </div>
      </React.Fragment>
    </div>
  );
}
